export const validationLettersOnly = str => {
  return /[`!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?~1234567890٠١٢٣٤٥٦٧٨٩१२३४५६७८९०೧೨೩೪೫೬೭೮೯೦୧୨୩୪୫୬୭୮୯୦]/g.test(
    str,
  )
}
